import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ColliderShapeComponent, ComponentIds, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import StoredColliderDataComponent from "../components/StoredColliderDataComponent";
export default class DisableColliderSystem extends SystemBase {
    constructor() {
        super(COMPONENT_IDS.DISABLED_COLLIDER_COMPONENT);
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "DisableColliderSystem";
    }
    onAddComponent(_entity, _newComponent) {
        const a = _entity.getComponent(ComponentIds.COLLIDER_SHAPE_COMPONENT_ID);
        if (!a)
            throw new Error("No polyhedron");
        const colliderPolyhedron = a.polyhedron;
        const ids = (a === null || a === void 0 ? void 0 : a.ids) || [];
        _entity.addComponent(new StoredColliderDataComponent(colliderPolyhedron, ids));
        _entity.removeComponent(ComponentIds.COLLIDER_SHAPE_COMPONENT_ID);
    }
    onRemoveComponent(_entity, _oldComponent) {
        const { collider, ids } = _entity.getComponent(COMPONENT_IDS.STORED_COLLIDER_DATA_COMPONENT) || {};
        if (!collider || !ids)
            return;
        _entity.addComponent(new ColliderShapeComponent(collider, ids));
        _entity.removeComponent(COMPONENT_IDS.DISABLED_COLLIDER_COMPONENT);
        _entity.removeComponent(COMPONENT_IDS.STORED_COLLIDER_DATA_COMPONENT);
    }
}
